<template>
  <bridge8-autocomplete
    outline
    class="mt-1 mb-0"
    label="Client"
    null-value-string="Net Rate"
    :data="clients"
    :search-string="client"
    @change="$emit('change', $event)"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Bridge8Autocomplete from './Bridge8Autocomplete'
import {errorCatch} from '../utils'

export default {
  name: 'AdminClientSelect',
  data () {
    return {
      client: null
    }
  },
  computed: {
    ...mapState('calc', {
      clients: state => state.data.clients
    })
  },
  methods: {
    ...mapActions(['apiFetchClientNames']),
    ...mapActions('calc', ['setData'])
  },
  mounted () {
    if (this.clients.length === 0) {
      this.apiFetchClientNames().then(data => this.setData({entity: 'clients', data: data}))
        .catch(errorCatch('Fetch Clients', this))
    }
  },
  components: {
    Bridge8Autocomplete
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdminClientSelect.vue